export default {



	////////////////////////////////////////////////////////////////
	//
	// Element styles
	//
	////////////////////////////////////////////////////////////////

	/**
	 * Returns base styles for element within a theme
	 * @type {string} theme to style with
	 * @type {string} component name 
	 * @type {string} id of element
	 * @return {Object} of styles
	 */

   methods: {

		getStyle: function(component)
		{

			let config = this.$store.getters.getCamapignConfig;
			switch(component) {
				case 'button':
					return { color: config.button_colour, backgroundColor: config.button_bg_colour };
				case 'secondary-button':
					return { 'border-color': config.button_bg_colour +' !important' };
				case 'p':
					return { color: config.font_normal_colour };
				case 'h1':
					return { color: config.font_header_colour, fontSize: config.font_header_size + 'px' };
				case 'h2':
					return { color: config.font_normal_colour, fontSize: config.font_header_size + 'px' };
				case 'number-circle':
					return { color: config.button_colour, backgroundColor: config.button_bg_colour, "border-color": config.button_bg_colour };
				case 'code':
					return { color: config.code_colour};
				case 'app':
					return {'background-color' : config.background_colour, 'font-family':config.font_family};
					default:
				// code block
			}
		}
	
}
  
   
}

